module.exports = __webpack_public_path__ + "img/nyfzbank.3353b455.png";